module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.info.white-44bffbf72d480ca47f1facff1a25baae.svg";